export * from './generateAlignmentClasses'
export * from './generateColorClasses'
export * from './generateFontClasses'
export * from './generateSpacingClasses'
export * from './backgroundImageMixin'
export * from './getMaxWidth'
export * from './getMinHeight'

export function bindStoryblokBridgeData(component) {
    const { _editable } = component || {}

    if (!_editable) return {}

    const blokOptions = JSON.parse(_editable.replace('<!--#storyblok#', '').replace('-->', ''))

    return {
        'data-blok-c': JSON.stringify(blokOptions),
        'data-blok-uid': blokOptions.id + '-' + blokOptions.uid,
    }
}

export function getScreenClassPrefix(mobileClass, tabletClass, desktopClass) {
    return [
        mobileClass,
        applyPrefixToClass('md:', tabletClass),
        applyPrefixToClass('lg:', desktopClass),
    ]
}

function applyPrefixToClass(prefix, value) {
    if (!value) return
    return Array.isArray(value) ? value.map((val) => `${prefix}${val}`) : `${prefix}${value}`
}
